// Mock Data for Rheumatology Category

const baseProducts = [
    {
        id: "med-rheum-1",
        name: "Methotrexate 15mg",
        genericName: "Brand: Trexall",
        indication: "Rheumatoid Arthritis",
        price: "$60",
        originalPrice: "$850",
        savings: "93%",
        description: "An immunosuppressant and antimetabolite drug used to treat severe, active rheumatoid arthritis. It helps decrease joint damage and preserve joint function.",
        dosage: "Usually taken once weekly. Follow your doctor's exact instructions.",
        packaging: "Contains 30 Tablets",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store at room temperature away from light and moisture.",
        sideEffects: "Nausea, vomiting, hair loss, or mouth sores. Regular blood tests required.",
        category: "DMARDs"
    },
    {
        id: "med-rheum-2",
        name: "Hydroxychloroquine 400mg",
        genericName: "Brand: Plaquenil",
        indication: "Lupus, Malaria, Arthritis",
        price: "$20",
        originalPrice: "$260",
        savings: "92%",
        description: "Used to treat symptoms of rheumatoid arthritis and systemic lupus erythematosus. It decreases pain and swelling in arthritis and skin problems in lupus.",
        dosage: "Typically taken once or twice daily with a meal.",
        packaging: "Contains 30 Tablets",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store at room temperature below 30°C.",
        sideEffects: "Headache, dizziness, nausea, or vision changes. Regular eye exams recommended.",
        category: "DMARDs"
    },
    {
        id: "med-rheum-3",
        name: "Adalimumab 40mg",
        genericName: "Brand: Humira (Biosimilar)",
        indication: "RA, Psoriatic Arthritis",
        price: "$1,440",
        originalPrice: "$6,500",
        savings: "78%",
        description: "A biologic therapy (TNF blocker) used to reduce signs and symptoms of rheumatoid arthritis, psoriatic arthritis, ankylosing spondylitis, and Crohn's disease.",
        dosage: "Administered as a subcutaneous injection, usually every other week.",
        packaging: "Contains 2 Pre-filled Syringes/Pens",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store in a refrigerator (2°C to 8°C). Do not freeze.",
        sideEffects: "Injection site pain, upper respiratory infections, or headache.",
        category: "Biologics"
    },
    {
        id: "med-rheum-4",
        name: "Etanercept 50mg",
        genericName: "Brand: Enbrel (Biosimilar)",
        indication: "RA, Psoriasis",
        price: "$1,440",
        originalPrice: "$6,800",
        savings: "79%",
        description: "Used to treat autoimmune diseases by acting as a tumor necrosis factor (TNF) inhibitor. Effective for moderate to severe rheumatoid arthritis and plaque psoriasis.",
        dosage: "Injected subcutaneously, typically once weekly.",
        packaging: "Contains 4 Pre-filled Syringes",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store refrigerated at 2°C to 8°C. Do not freeze or shake.",
        sideEffects: "Redness/itching at the injection site, cold symptoms, or mild weakness.",
        category: "Biologics"
    },
    {
        id: "med-rheum-5",
        name: "Infliximab 100mg",
        genericName: "Brand: Remicade (Biosimilar)",
        indication: "RA, Crohn's, UC",
        price: "$1,080",
        originalPrice: "$5,600",
        savings: "80%",
        description: "A biologic medication given by intravenous infusion to treat rheumatoid arthritis, Crohn's disease, ulcerative colitis, and ankylosing spondylitis.",
        dosage: "Administered via IV infusion under medical supervision. Dosing schedule varies.",
        packaging: "Contains 1 Vial for Reconstitution",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store vials in a refrigerator between 2°C and 8°C.",
        sideEffects: "Infusion reactions, headache, abdominal pain, or fatigue.",
        category: "Biologics"
    }
];

const generateAlphabetMeds = () => {
    const meds = [];
    const alphabets = "ABCDEFGHIJKLMNOPQRSTUVWXY".split(""); // 25 letters
    let priceBase = 2000;
    let ourPriceBase = 180;
    let dosageCount = 100;

    alphabets.forEach((letter, index) => {
        const id = `med-rheum-alpha-${index + 6}`;
        const name = `Medication ${letter} ${dosageCount}mg`;
        const originalPrice = priceBase;
        const price = ourPriceBase;
        const discount = Math.round(((originalPrice - price) / originalPrice) * 100);

        meds.push({
            id: id,
            name: name,
            genericName: `Medication Generic ${letter} ${dosageCount}mg`,
            indication: "Rheumatology and Autoimmune Conditions",
            price: `$${price}`,
            originalPrice: `$${originalPrice.toLocaleString()}`,
            savings: `${discount}%`,
            description: `Quality generic medication for the treatment of inflammatory and autoimmune conditions including Rheumatoid Arthritis. Sourced from WHO-GMP certified facilities ensuring efficacy and safety.`,
            dosage: "As prescribed by your rheumatologist.",
            packaging: "Contains 30 Tablets/Capsules",
            manufacturer: "Licensed Top Indian Manufacturer",
            storage: "Store below 25°C in a cool, dry place. Protect from light.",
            sideEffects: "Consult your doctor for specific side effects. Regular monitoring may be required.",
            category: "General Rheumatology Care"
        });

        dosageCount += 25; // Increase dosage
        if (index % 3 === 0) {
            priceBase += 400;
            ourPriceBase += 30;
        } else if (index % 2 === 0) {
            priceBase -= 200;
            ourPriceBase -= 15;
        } else {
            priceBase += 600;
            ourPriceBase += 40;
        }
    });

    return meds;
};

// Combine the two sets of products
export const rheumatologyProducts = [...baseProducts, ...generateAlphabetMeds()];

export const rheumatologyHeroData = {
    title: "Rheumatology",
    subtitle: "Rheumatoid arthritis, lupus, and autoimmune disease treatments",
    description: "Access high-quality, authentic medications for the management of rheumatoid arthritis, lupus, and other complex autoimmune conditions. Our global network connects you to affordable generics and biosimilars.",
    stats: [
        { number: "30+", label: "Medications" },
        { number: "80%", label: "Average Savings" }
    ]
};

export const rheumatologyCategories = [
    "All Categories",
    "DMARDs",
    "Biologics",
    "NSAIDs",
    "Corticosteroids",
    "General Rheumatology Care"
];

export const rheumatologyTrustBadges = [
    { text: "WHO-GMP Certified Sources", icon: "ShieldCheck" },
    { text: "Cold-Chain Logistics", icon: "Thermometer" },
    { text: "Verified Pharmacists", icon: "Users" },
    { text: "Authenticity Guaranteed", icon: "Award" }
];

export const rheumatologyFAQs = [
    {
        question: "Do you require a prescription for specialty biologics?",
        answer: "Yes. All specialty rheumatology medications, especially biologics and DMARDs, require a valid prescription from a licensed rheumatologist or physician."
    },
    {
        question: "How do you ship temperature-sensitive biologics like Adalimumab?",
        answer: "We use specialized cold-chain logistics. Temperature-sensitive medications are shipped in validated, temperature-controlled packaging with data loggers to ensure they remain between 2°C and 8°C throughout transit."
    },
    {
        question: "Are these biosimilars as safe and effective as the original brands?",
        answer: "Yes. The biosimilars we supply are rigorously tested and approved to have no clinical differences in safety, purity, and potency compared to their reference products."
    },
    {
        question: "Can I receive ongoing maintenance medications internationally?",
        answer: "Absolutely. We specialize in providing reliable, continuous supplies of maintenance therapies to patients worldwide."
    }
];

export const rheumatologyTestimonials = [
    {
        name: "Sarah W.",
        country: "United States",
        savings: "$60,000 annually",
        condition: "Severity Rheumatoid Arthritis",
        medication: "Adalimumab (Humira Biosimilar)",
        text: "Accessing biologics in the US was bankrupting my family. Sourcing my Adalimumab through MediSeller has saved us tens of thousands of dollars without compromising my treatment."
    },
    {
        name: "David M.",
        country: "Canada",
        savings: "$12,000 annually",
        condition: "Psoriatic Arthritis",
        medication: "Etanercept (Enbrel Biosimilar)",
        text: "The cold-chain shipping works perfectly. My medication always arrives chilled, and my arthritis symptoms are completely under control thanks to these affordable biosimilars."
    },
    {
        name: "Priya K.",
        country: "United Kingdom",
        savings: "$8,500 annually",
        condition: "Lupus",
        medication: "Hydroxychloroquine",
        text: "Consistent supply of my maintenance medications is crucial. MediSeller ensures I never run out, and the cost savings on bulk orders are exceptional."
    }
];

export const rheumatologySectionContent = {
    testimonials: {
        title: "Patient Success Stories",
        description: "Learn how patients are successfully managing chronic autoimmune conditions through affordable treatment."
    },
    faqs: {
        title: "Frequently Asked Questions",
        description: "Important information about ordering specialty rheumatology medications and biologics."
    },
    midPageCTA: {
        title: "Searching for a Specific Biologic?",
        description: "Our procurement experts can source a wide range of DMARDs and biosimilars globally. Let us help you find your prescribed treatment.",
        whatsappText: "Chat on WhatsApp",
        requestText: "Request Sourcing Assistance"
    },
    finalCTA: {
        title: "Regain Control with Affordable Treatment",
        description: "Don't let the cost of rheumatology medications prevent you from living an active life. Secure your treatment today.",
        whatsappText: "Start WhatsApp Chat",
        requestText: "Submit Prescription"
    },
    adminFooter: {
        brandName: "MediSeller Global",
        copyrightYear: "2025",
        rightsText: "All rights reserved. | Licensed International Pharmacy"
    }
};
